import React from 'react';
import { Sparkles } from 'lucide-react';

export const GalateaIAButton: React.FC = () => {
  return (
    <button
      type="button"
      className="flex items-center gap-2 px-4 py-1.5 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white rounded-lg transition-all border border-indigo-400/50 shadow-lg shadow-indigo-500/20 text-sm font-medium"
      title="Acionar Inteligência Artificial (Em breve)"
      onClick={() => alert('Galatea IA será ativada nesta tela em breve!')}
    >
      <Sparkles size={16} className="animate-pulse text-indigo-100" />
      <span>Galatea IA</span>
    </button>
  );
};
